import $ from 'jquery'
import _ from 'lodash'
import 'rangeslider.js'
import { format } from 'date-fns'
import { uk } from 'date-fns/locale'

import { AMOUNTS, INSTALLMENTS } from './rangeslider'
import { selectors } from '../selectors'
import { elementExists } from '../shared'
import { formatNumberAndCurrency, formatNumberAndPercents } from '../formater'
import { calculateAPR } from './apr'
import Calculator, { generateRawPayments } from './calculator'

const RESULT_CELLS = [
    { selector: selectors.blocks.duration, mapTo: 'duration' },
    { selector: selectors.blocks.amount, mapTo: 'amount' },
    { selector: selectors.blocks.interest, mapTo: 'interest' },
    { selector: selectors.blocks.repayable, mapTo: 'repayable' },
    { selector: selectors.blocks.APR, mapTo: 'APR' },
]

// ----------------------- Tables -----------------------

const formState = {
    get: () => ({
        productType: _.reduce(AMOUNTS, (accum, wrapper) => accum ?? $(wrapper.selector).parents('form').attr('id'), null),
        amount: Number.parseFloat(_.reduce(AMOUNTS, (accum, wrapper) => accum ?? $(wrapper.selector).find(selectors.sliders.input).val(), null)),
        installments: Number.parseInt(_.reduce(INSTALLMENTS, (accum, wrapper) => accum ?? $(wrapper.selector).find(selectors.sliders.instalmentsFocused).val(), null)),
    }),
}

// -------------------------------------------------------------------

export const renderLoanInfoTable = () => {
    const { productType, amount, installments } = formState.get()
    const options = window.options ?? {}

    if (!productType || !amount || !installments) {
        return
    }

    const calculator = new Calculator(amount, installments, options)
    const table = calculator.getTable()

    // console.table(table)

    const interest = Object.values(table).reduce((sum, item) => sum + item.iPmt, 0.0) // Total Interest
    const rawPayments = generateRawPayments(table, installments) // Transformation of data
    const APR = calculateAPR([{ amount, fee: 0, day: 0 }], rawPayments) // APR in percentage

    const monthlyPayment = Math.max(...Object.values(table).map((row) => row.pmt))
    const totalRepayable = Object.values(table).reduce((sum, row) => sum + row.pmt, 0.0)
    const amountFormatted = formatNumberAndCurrency(amount)
    const monthlyFormatted = formatNumberAndCurrency(monthlyPayment)
    const totalFormatted = formatNumberAndCurrency(totalRepayable)

    const recalculated = {
        duration: installments,
        amount: amountFormatted,
        interest: formatNumberAndCurrency(interest),
        repayable: monthlyFormatted,
        APR: formatNumberAndPercents(APR),
    }

    // TODO chtelo by REF! Neni citelne
    RESULT_CELLS.forEach((cellOBJ) => {
        const $tableCell = $(cellOBJ.selector)
        $tableCell.text('')
        $tableCell.append(recalculated[cellOBJ.mapTo])
    })

    $('#reprAmount').text(amountFormatted)
    $('#reprTerm').text(installments)
    $('#reprCount').text(installments)
    $('#reprMonthly').text(monthlyFormatted + '.')
    $('#reprTotal').text(totalFormatted)

    $('#calcMonthly').text(monthlyFormatted)
    $('#calcTotal').text(totalFormatted)
}

// -------------------------------------------------------------------

const shouldRenderPaymentCalendar = () => elementExists('#installments-tbody')

export const renderPaymentCalendar = () => {
    if (!shouldRenderPaymentCalendar()) return

    const { productType, amount, installments } = formState.get()
    const options = window.options ?? {}

    const calculator = new Calculator(amount, installments, options)
    const table = calculator.getTable()

    if (!productType || !amount || !installments) {
        return
    }

    const $tbody = $('#installments-tbody')
    $tbody.empty()

    for (let i = 1; i <= installments; i++) {
        // Not table[i].pmt: the stored instalment is round(principal) + round(interest) with the
        // remainder reconciled on the last one, see LoanInstallmentInfoFactory::create().
        const dueAmount = formatNumberAndCurrency(calculator.calculateAmountFee(i))
        const dateExpected = format(table[i].dateExpected, 'dd.MM.yyyy', { locale: uk })

        const row = `
            <div class="offer__schedule-row">
                <div class="offer__schedule-row-label">Installment ${i}</div>
                <div class="offer__schedule-row-value"><strong>${dueAmount}</strong> <span class="offer__schedule-row-date">• ${dateExpected}</span></div>
            </div>
        `
        $tbody.append(row)
    }
}
